const contactFormPharmacy = {
  page: {
    title: 'Contact Pharmacy',
    description: 'For questions about prices, availability, or the pharmacy inventory, please use the contact form below. We will immediately forward your inquiry to the team of your selected pharmacy.',
  },
  forms: {
    salutation: 'Salutation',
    firstName: 'First Name *',
    lastName: 'Last Name *',
    phoneNumber: 'Phone Number',
    email: 'Email Address *',
    message: 'Your Message *',
    ourPromise: '{strongText} We use your phone number only for possible queries from the pharmacy regarding your pre-orders. Additionally, you will be informed about the status of your order via SMS and email.',
    ourPromiseTitle: 'Our Promise:',
    policy: {
      termsOfUse: 'Terms of Use',
      privacyPolicy: 'Privacy Policy',
      1: 'I have read and acknowledge the',
      2: 'and',
      3: ', and I agree to their terms.',
    },
    send: 'Send',
  },
  success: {
    title: 'Contact Form',
    description: 'Thank you for your message to Testapotheke IhreApotheken.de. Your pharmacy will contact you as soon as possible. We have sent a copy of your message to the email address you provided.',
    button: 'Back to Home',
  },
}

export default contactFormPharmacy
